import React from "react";
import { keyframes } from "@mui/system";
import Box from "@mui/material/Box";

interface LoadingProps {
  backgroundColor: string;
  color1: string;
  color2: string;
  size?: number;
}

const wave = keyframes`
  0%, 40%, 100% { transform: translateY(0); }
  20% { transform: translateY(-50%); }
`;

const Loading: React.FC<LoadingProps> = ({
  backgroundColor,
  color1,
  color2,
  size = 80,
}) => {
  const dotSize = size * 0.25;
  const gap = dotSize * 0.2;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <Box sx={{ display: "flex", gap }}>
        {[0, 1, 2, 3, 4].map((i) => (
          <Box
            key={i}
            sx={{
              width: dotSize,
              height: dotSize,
              borderRadius: "50%",
              background: i % 2 === 0 ? color1 : color2,
              animation: `${wave} 1.2s ease-in-out infinite`,
              animationDelay: `${i * 0.15}s`,
              boxShadow: `0 2px ${dotSize * 0.4}px rgba(0,0,0,0.25)`,
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default Loading;
